<template>
    <PageLayout :has-buttons="true" :has-title="false" content-class="p-0" :has-page-scroll="false">
        <template #content>
            <section
                class="card w-100 h-100 d-flex flex-column align-items-center justify-content-center"
                v-if="isLoadError || isFormLoading || isSaveInProgress"
            >
                <div class="d-flex flex-column align-items-start" v-if="isLoadError && !isFormLoading">
                    <h5 class="fw-bold">Error</h5>
                    <p class="font-size-xl mb-1">
                        <template v-if="referralId">
                            There was problem while loading the referral. Please try again.
                        </template>
                        <template v-else>
                            There was problem while generating the referral form. Please try again.
                        </template>
                    </p>
                    <button class="btn btn-primary" @click="loadReferral()">Try Again</button>
                </div>
                <div v-if="!isLoadError && isFormLoading" class="d-flex flex-column">
                    <i class="fas fa-clipboard-list fa-7x text-primary animated flash infinite slow mb-2"></i>
                    <span class="font-size-xl">Loading Referral Form...</span>
                </div>
                <div v-if="isSaveInProgress" class="d-flex flex-column align-items-center">
                    <i class="far fa-save fa-7x text-primary animated flash infinite slow mb-2"></i>
                    <span class="font-size-xl text-center">Saving Referral...</span>
                </div>
            </section>
            <template v-if="!isLoadError && !isFormLoading && !isSaveInProgress">
                <div id="HosPal_New_Referral">
                    <div class="convert-header mb-1">
                        {{ ` ${applicationId == hospiceApplicationId ? "Hospice" : "Pallative Care"} Referral` }}
                    </div>
                    <div class="card mx-2 mb-4">
                        <div class="card-body form-content p-3 mx-lg-6">
                            <div class="mb-3"><HosPalReferralInformation :provider-id="providerId" /></div>
                            <div class="mb-3">
                                <DemographicsInformation
                                    :referral="referral"
                                    :is-patient="false"
                                    :provider-id="providerId"
                                    :is-his-section="isHisSection"
                                    :is-refer="isRefer"
                                    :is-create="isCreate"
                                >
                                    <template #tags>
                                        <PatientTags :patient="referral" :provider-id="providerId"></PatientTags>
                                    </template>
                                </DemographicsInformation>
                            </div>
                            <div class="mb-3">
                                <PayorInformation :provider-id="providerId" :is-his-section="isHisSection" />
                            </div>
                            <div class="mb-3">
                                <AdmissionInformation
                                    v-if="referral.application == hospiceApplicationId"
                                    :is-read-only="false"
                                />
                            </div>
                            <div v-if="!loadReferAuthorizedContact" class="mb-3">
                                <PatientAuthorizedContacts
                                    :patient-id="referralId"
                                    :application="referral.application"
                                    :account-id="referral.accountId"
                                    :patient-primary-address="referral.primaryAddress"
                                    :referred-contact="referringAuthorizedContact"
                                />
                            </div>
                            <div v-if="referral.application == palliativeApplicationId" class="mb-3">
                                <PatientGoals :referral="referral" />
                            </div>
                            <div class="mb-3">
                                <ClinicianInformation
                                    :provider-id="providerId"
                                    :referring-patient-diagnosis="referringPatientDiagnosis"
                                />
                            </div>
                            <div class="mb-3">
                                <PatientHealthHistory
                                    v-if="referral.application == palliativeApplicationId"
                                    :patient="referral"
                                />
                            </div>
                            <div class="mb-3">
                                <ReferralDocuments
                                    :referral="referral"
                                    :provider-id="providerId"
                                    v-if="referral.id && canShowReferralDocuments"
                                />
                            </div>
                            <div class="mb-3">
                                <ReferralReadiness :referral="referral" />
                            </div>
                            <PatientPreadmissionNotes
                                ref="notesSection"
                                :application="applicationId"
                                :referral-id="referralId"
                                :is-referral="true"
                                :referral="referral"
                            />
                        </div>
                    </div>
                    <footer
                        class="d-flex justify-content-center form-footer gap-2"
                        v-if="!isLoadError && !isFormLoading && !isSaveInProgress"
                    >
                        <button type="button" class="btn btn-primary me-2" @click="handleConvertToPending(referral)">
                            Convert to Pending
                        </button>
                        <button type="button" class="btn btn-primary me-2" @click="update()" v-if="!isCreate">
                            Save Referral
                        </button>
                        <button type="button" class="btn btn-primary me-2" @click="create()" v-else>
                            Create Referral
                        </button>
                        <button class="btn btn-outline-primary me-2" @click="goToReferralList()">
                            View Referral List
                        </button>
                        <button class="btn btn-outline-primary" @click="goToReferralList(true)">Cancel</button>
                    </footer>
                </div>
            </template>
        </template>
    </PageLayout>
</template>

<style src="./CreateReferralHosPal.scss"></style>
<script lang="ts" src="./CreateReferralHosPal.ts"></script>
